define('cartware/components/Holepunch',[
	"jquery",
	"./Utilities"
], function(
	$,
	Utils
) {
	function Holepunch() {
		this.url		= Utils.getPath(window, "gigaset.holepunch.url");
		this.handle		= Utils.getPath(window, "gigaset.request.action");
		this.product	= Utils.getPath(window, "gigaset.request.product");
		this.category	= Utils.getPath(window, "gigaset.request.category");
		this.excludedRefererList = JSON.parse(Utils.getPath(window, "gigaset.holepunch.utm.excludedRefererList"));
		this.utmParams  = this.getUtmParams();
		this.isHolepunchActive = Utils.getPath(window, "gigaset.holepunch.active");
		this.hasUtmParams = !$.isEmptyObject(this.utmParams);
		this.isUtmTrackingActive = Utils.getPath(window, "gigaset.holepunch.utm.active");
		this.deferred	= $.Deferred();

		if (this.isHolepunchActive ||
			(this.isUtmTrackingActive && this.hasUtmParams)
		) {
			$($.proxy(this.load, this));
		}
	}

	Holepunch.prototype = {
		url:		null,
		handle:		null,
		product:	null,
		category:	null,
		utmParams: null,

		deferred:	null,

		load: function() {
			// fresh holepunch
			if (this.deferred.state() !== "pending") {
				this.deferred = $.Deferred();
			}

			var xhr = $.ajax({
				url: this.url,
				type: "POST",
				dataType: "JSON",
				data: {
					handle:		this.handle,
					product:	this.product,
					category:	this.category,
					info:		Utils.getPath(window, "gigaset.holepunch.info") || {},
					utmParams:  this.utmParams,
					isHolepunchActive: this.isHolepunchActive
				}
			});

			xhr.done($.proxy(function(data) {
				this.deferred.resolveWith(null, [data]);
				this.fill(data);
			}, this));

			xhr.fail($.proxy(this._onError, this));

			return this;
		},

		ready: function(cb) {
			this.deferred.then(cb);
		},

		fill: function(data) {
			if ("blocks" in data) {
				$.each(data.blocks, function(index, value) {
					$('#' + index.replace(/(:|\.|\[|\])/g, "\\$1")).replaceWith(value);
				});
			}
		},

		_onError: function(jqXHR, textStatus, errorThrown) {
			if ("console" in window && "undefined" !== typeof console.error) {
				console.error(errorThrown);
				console.log(jqXHR);
			}
		},

		getUtmParams: function () {
			var urlParams = this.getAllParams(),
				utmParams = ['utm_campaign', 'utm_medium', 'utm_source', 'utm_term', 'utm_content'],
				utmParamsValues = {};

			$.each(utmParams, function (index, value) {
				var paramValue = Utils.getPath(urlParams, value);
				if (paramValue) {
					utmParamsValues[value] = paramValue;
				}
			});

			if (window.document.referrer &&
				!this._isInternalReferer() &&
				!this._isPaymentThirdPartyReferer() &&
				!this._isInCheckoutPage()
			) {
				utmParamsValues.referer = window.document.referrer;
			}

			return utmParamsValues;
		},

		_isInternalReferer: function() {
			return window.document.referrer.indexOf(location.protocol + '//' + location.host) === 0;
		},

		_isInCheckoutPage: function() {
			var checkoutLinks = ['checkout/cart', 'checkout/cart/index', 'checkout/onepage', 'checkout/onepage/index'],
				patternPrefix = '^' + location.protocol + '//' + location.host + '/[a-z]{2}_[a-z]{2}/',
				patternSuffix = '/*$',
				isInCheckoutPage = false;

			$.each(checkoutLinks, function (index, value) {
				if (new RegExp(patternPrefix + value + patternSuffix).match(window.location.href)) {
					isInCheckoutPage = true;
					return false;
				}
			});

			return isInCheckoutPage;
		},

		_isPaymentThirdPartyReferer: function() {
			var isExcludedReferer = false;
			$.each(this.excludedRefererList, function(index, value) {
				if (value !== '' && window.document.referrer.indexOf(value) === 0) {
					isExcludedReferer = true;
					return false;
				}
			});
			return isExcludedReferer;
		},

		getAllParams: function () {
			var params = {};
			window.location.search.slice(1).split('&').forEach(function(elm) {
				if (elm === '') return;
				var spl = elm.split('='),
					d = decodeURIComponent;
				params[d(spl[0])] = (spl.length >= 2 ? d(spl[1]) : true);
			});

			return params;
		}
	};

	return (new Holepunch());
});
